"use strict";

// Voice previews (generated takes, trained voice samples) play one at a time:
// starting one pauses whichever was playing.
let activeAudio = null;

export const playExclusively = (audio) => {
  if (activeAudio && activeAudio !== audio) {
    activeAudio.pause();
  }
  activeAudio = audio;
  return audio.play();
};
